import React, { useEffect, useRef } from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';

const PlayerContextMenu = ({
  visible,
  x,
  y,
  playerData,
  onAddToBetslip,
  onClose,
  onToggleScratchpad,
  isInScratchpad,
}) => {
  const menuRef = useRef(null);
  const { isDarkMode } = useDarkMode();

  useEffect(() => {
    if (!visible) return;

    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };

    const handleScroll = () => onClose();

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    window.addEventListener('scroll', handleScroll, true);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [visible, onClose]);

  if (!visible) return null;

  const inScratchpad = !!(isInScratchpad && playerData && isInScratchpad(playerData));

  const itemStyle = {
    padding: '8px 14px',
    cursor: 'pointer',
    color: isDarkMode ? '#e0e0e0' : '#212529',
    fontSize: '0.9rem',
    whiteSpace: 'nowrap',
  };

  const hoverIn = (e) => { e.currentTarget.style.backgroundColor = isDarkMode ? '#3a3a3a' : '#f0f0f0'; };
  const hoverOut = (e) => { e.currentTarget.style.backgroundColor = 'transparent'; };

  return (
    <div
      ref={menuRef}
      style={{
        position: 'fixed',
        left: x,
        top: y,
        zIndex: 10050,
        backgroundColor: isDarkMode ? '#2b2b2b' : '#ffffff',
        border: `1px solid ${isDarkMode ? '#444' : '#ccc'}`,
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        minWidth: '160px',
        padding: '4px 0',
      }}
    >
      {onAddToBetslip && playerData?.bookmaker && playerData?.odds != null && (
        <div
          style={itemStyle}
          onMouseEnter={hoverIn}
          onMouseLeave={hoverOut}
          onClick={() => {
            onAddToBetslip(playerData);
            onClose();
          }}
        >
          Add to Betslip
        </div>
      )}
      {onToggleScratchpad && (
        <div
          style={{ ...itemStyle, display: 'flex', alignItems: 'center', gap: '8px' }}
          onMouseEnter={hoverIn}
          onMouseLeave={hoverOut}
          onClick={() => {
            onToggleScratchpad(playerData);
            onClose();
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ flexShrink: 0, color: '#a78bfa' }}
          >
            <path
              d="M5 4a2 2 0 0 1 2-2h9l4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
            <path
              d="M9 9h6M9 13h6M9 17h4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            {inScratchpad && (
              <path
                d="M5 5l14 14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            )}
          </svg>
          <span>{inScratchpad ? 'Remove from Scratchpad' : 'Add to Scratchpad'}</span>
        </div>
      )}
    </div>
  );
};

export default PlayerContextMenu;
